var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1113 33.5868C46.1113 37.5233 42.906 40.7287 38.9695 40.7287H0.111328V12.4426C0.111328 8.50616 3.31671 5.30078 7.25314 5.30078H46.1113V33.5868Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0732 7.69092C33.2615 7.69092 30.9559 9.96842 30.9559 12.8083V18.1225H38.182C38.3507 18.1225 38.5475 18.1225 38.6881 18.1506C40.3189 18.2349 41.528 19.0784 41.528 20.5405C41.528 21.6934 40.7126 22.6775 39.1942 22.8743V22.9305C40.8532 23.043 42.1184 23.9709 42.1184 25.4049C42.1184 26.9513 40.7126 27.9635 38.8568 27.9635H30.9277V38.367H38.4351C41.2468 38.367 43.5524 36.0894 43.5524 33.2496V7.69092H36.0732Z",
    fill: "url(#paint0_linear_458_17932)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4583 26.3327H36.4106C36.4528 26.3327 36.5231 26.3257 36.5934 26.3186C36.6637 26.3116 36.734 26.3046 36.7761 26.3046C37.3385 26.1921 37.8165 25.686 37.8165 24.9831C37.8165 24.3083 37.3385 23.8021 36.7761 23.6616C36.6918 23.6334 36.5231 23.6334 36.4106 23.6334H33.4583V26.3327Z",
    fill: "url(#paint1_linear_458_17932)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4106 19.6689C36.973 19.7533 37.451 20.2031 37.451 20.8779C37.451 21.5528 36.973 22.0026 36.4106 22.087C36.3825 22.1151 36.2138 22.1151 36.1294 22.1151H33.4583V19.6408H36.1294C36.1759 19.6408 36.2394 19.6493 36.2964 19.657C36.343 19.6632 36.3853 19.6689 36.4106 19.6689Z",
    fill: "url(#paint2_linear_458_17932)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78805 7.69092C4.97632 7.69092 2.6707 9.96842 2.6707 12.8083V25.433C4.10468 26.1359 5.5949 26.5858 7.08512 26.5858C8.85651 26.5858 9.8125 25.5173 9.8125 24.0552V18.0943H14.1988V24.0271C14.1988 26.3327 12.7648 28.2166 7.90052 28.2166C4.9482 28.2166 2.64258 27.5699 2.64258 27.5699V38.3388H10.1499C12.9616 38.3388 15.2673 36.0613 15.2673 33.2215V7.69092H7.78805Z",
    fill: "url(#paint3_linear_458_17932)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9299 7.69092C19.1181 7.69092 16.8125 9.96842 16.8125 12.8083V19.5002C18.1059 18.4036 20.3553 17.7007 23.9824 17.8694C25.9225 17.9538 28.0032 18.488 28.0032 18.488V20.653C26.9629 20.1188 25.7257 19.6408 24.123 19.5283C21.3675 19.3315 19.7086 20.6811 19.7086 23.043C19.7086 25.433 21.3675 26.7826 24.123 26.5577C25.7257 26.4452 26.9629 25.9391 28.0032 25.433V27.598C28.0032 27.598 25.9506 28.1322 23.9824 28.2166C20.3553 28.3853 18.1059 27.6824 16.8125 26.5858V38.3951H24.3198C27.1316 38.3951 29.4372 36.1176 29.4372 33.2777V7.69092H21.9299Z",
    fill: "url(#paint4_linear_458_17932)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_17932",
    x1: 30.9503,
    y1: 20.8737,
    x2: 43.5859,
    y2: 20.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_17932",
    x1: 30.9503,
    y1: 20.8737,
    x2: 43.5859,
    y2: 20.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_458_17932",
    x1: 30.9503,
    y1: 20.8737,
    x2: 43.5859,
    y2: 20.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_458_17932",
    x1: 2.6643,
    y1: 23.0162,
    x2: 15.4954,
    y2: 23.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_458_17932",
    x1: 16.7394,
    y1: 23.0162,
    x2: 29.201,
    y2: 23.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.ef65e67b1858fc5158b31166b0805b72.svg";
export { ForwardRef as ReactComponent };